import {
  Container as MaterialContainer,
  AccordionDetails,
  Grid,
  Divider,
  Box,
} from "@mui/material";
import { formControlLabelClasses } from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import "@fontsource/manrope";
import { createStyles, makeStyles } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";

export const useStyles = makeStyles(() =>
  createStyles({
    radioButton: {
      [`&.${formControlLabelClasses.root}`]: {
        margin: "0px !important",
      },
    },
  })
);

export const Container = styled(MaterialContainer)(() => ({
  marginTop: "42px",
  width: "100%",
  maxWidth: "1440px",
}));

export const StepsWrapper = styled("div")(() => ({
  minHeight: "700px",
}));

export const AccordionDetailsWrapper = styled(AccordionDetails)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "32px 24px",
}));

export const FieldsContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "start",
  gap: "24px",
});

type ChooseTypeBoxProps = {
  selected: boolean;
  optionQuantity: number;
  optionSpacing: string;
};

export const ChooseBox = styled(Grid)(
  ({ selected, optionQuantity, optionSpacing }: ChooseTypeBoxProps) => ({
    display: "flex",
    border: `1px solid ${selected ? colors.brandBlue500 : colors.gray200}`,
    borderRadius: "12px",
    maxWidth: `calc(${100 / optionQuantity}% - ${optionSpacing})`,
    cursor: "pointer",
  })
);

export const ChooseTypeBox = styled(ChooseBox)(() => ({
  flexDirection: "column",
  justifyContent: "center",
  padding: "16px",
  height: "92px",
  margin: "0px",
  width: "100%",
}));

export const ChooseOwnershipBox = styled(ChooseBox, { name: "ChooseOwnershipBox" })(() => ({
  alignItems: "center",
  margin: "0px",
  height: "56px",
  overflow: "hidden",
  padding: "0px",
  width: "100%",

  [`& .${formControlLabelClasses.root}`]: {
    height: "fit-content !important",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));

export const OwnershipSubcontractorBox = styled(Grid)(() => ({
  marginTop: "42px",
}));

export const FileInputBox = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: "100%",
  height: 250,
  border: `1px dashed ${colors.gray300}`,
  borderRadius: "4px",
  cursor: "pointer",
  position: "relative",
  "& span:nth-of-type(1)": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.1px",
  },
  "& span:nth-of-type(2)": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20x",
    letterSpacing: "0.25px",
  },
  "& span:nth-of-type(3)": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20x",
    letterSpacing: "0.25px",
  },
}));

export const FieldContainer = styled(Grid)(() => ({
  padding: "0px 0px",
}));

export const BranchOption = styled("li")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  padding: "0 !important",
}));

export const BranchOptionText = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const StorageBoxLoadableDivider = styled(Divider)(() => ({
  marginLeft: "-16px",
  width: "calc(100% + 32px)",
  margin: "32px 0",
}));

export const LeftContentContainer = styled("div")(() => ({
  maxWidth: "255px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));

export const IconsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px 0",
}));

export const IconsTitle = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const IconBoxContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "stretch",
  gap: "12px",
  flexWrap: "wrap",
  position: "relative",
  maxHeight: "132px",
}));

type IconBoxProps = {
  selected: boolean;
};
export const IconBox = styled("div")(({ selected }: IconBoxProps) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: `${selected ? 2 : 1}px solid ${selected ? colors.brandBlue500 : colors.gray200}`,
  borderRadius: "8px",
  height: "60px",
  width: "60px",
  backgroundColor: colors.white,
  cursor: "pointer",
  position: "relative",
}));

export const CheckedBox = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "20px",
  width: "20px",
  borderRadius: "20px",
  padding: "4px",
  position: "absolute",
  right: "-8px",
  top: "-8px",
  backgroundColor: colors.success500,
}));

export const Footer = styled(Box)(() => ({
  display: "flex",
  padding: "16px 24px",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
  borderRadius: "8px",
  border: `1px solid ${colors.gray200}`,
  backgroundColor: colors.white,
  marginTop: "32px",
  marginBottom: "16px",
}));
